var map = {
	"./Basic/BinLabelsOnDemandForm.tsx": 87424,
	"./Basic/ContactUsForm.tsx": 77026,
	"./Basic/CustomCatalogForm.tsx": 49579,
	"./Basic/CustomerApplicationFormFull.tsx": 85304,
	"./Basic/CustomerApplicationFormShort.tsx": 59339,
	"./Basic/CustomerLogo.tsx": 26102,
	"./Basic/DownloadPricingForm.tsx": 69841,
	"./Basic/IconLink.tsx": 49744,
	"./Basic/MarketContactUsForm.tsx": 4668,
	"./Basic/ScrollingBanner.tsx": 56292,
	"./Basic/Slider.tsx": 27792,
	"./Basic/Spacer.tsx": 24915,
	"./Common/NavigationGrid.tsx": 71398,
	"./Common/NewProductLinkList.tsx": 9512,
	"./Common/RecentBlogs.tsx": 72470,
	"./Common/SmallHeadingAnd2TextLines.tsx": 55150,
	"./Common/XCSearchTextField.tsx": 81420,
	"./Footer/CustomFooter.tsx": 19599,
	"./Header/CustomHeader.tsx": 42122
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22587;